// @flow
import { NOT_FRIEND, FRIEND, THEY_REQUESTED, YOU_REQUESTED } from '../constants/friendStatusTypes';

function decodeUser(p: Object = {}): User {
  const status = p.relationship_status ? p.relationship_status.id : NOT_FRIEND;
  let sortOrder = 4;

  switch (status) {
    case FRIEND:
      sortOrder = 1;
      break;
    case THEY_REQUESTED:
      sortOrder = 2;
      break;
    case YOU_REQUESTED:
      sortOrder = 3;
      break;
    default:
  }

  return {
    avatar: p.avatar,
    id: p.id,
    status,
    username: p.name,
    sortOrder
  };
}

export default decodeUser;
